import React, { useState, Fragment, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
} from "reactstrap"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"

import {
  getCourseKnowledges,
  editCourseKnowledgeClean,
  addCourseKnowledgeClean,
} from "../../store/actions"
import "../../assets/scss/datatables.scss"
import { useDispatch, useSelector } from "react-redux"
import CourseKnowledgesForm from "./CourseKnowledgesForm"

const CourseKnowledgeListTable = props => {
  const dispatch = useDispatch()
  const { SearchBar } = Search

  const [insertModal, setInsertModal] = useState(false)
  const [updateModal, setUpdateModal] = useState(false)
  const [courseKnowledge, setCourseKnowledge] = useState({
    idKnowledge: 0,
  })

  const { error, loading, done, courseKnowledges } = useSelector(state => ({
    error: state.CourseKnowledgesList.error,
    loading: state.CourseKnowledgesList.loading,
    courseKnowledges: state.CourseKnowledgesList.courseKnowledges,
    done: state.CourseKnowledgesList.done,
  }))

  useEffect(() => {
    dispatch(getCourseKnowledges())
  }, [])

  const handleEdit = courseKnowledge => {
    setCourseKnowledge(courseKnowledge)
    setUpdateModal(true)
  }

  const buttonActions = (cell, row, rowIndex, extraData) => {
    return (
      <button
        className="btn btn-primary"
        key={`button-${row.idKnowledge}`}
        onClick={() => handleEdit(row)}
      >
        Editar
      </button>
    )
  }

  const columns = [
    {
      dataField: "idKnowledge",
      text: "Id",
      sort: false,
      hidden: true,
    },
    {
      dataField: "knowledge",
      text: "Nombre del conocimiento",
      sort: true,
    },
    {
      dataField: "status",
      text: "Estatus",
      sort: true,
      align: "center",
      headerAlign: "center",
      // eslint-disable-next-line react/display-name
      formatter: (cell, row, rowIndex, extraData) => {
        return (
          <h4 style={{ marginBottom: 0 }} key={`status-${row.idKnowledge}`}>
            <span
              className={`pt-2 badge bg-${row.status ? "success" : "warning"}`}
            >
              {row.status ? "Activo" : "Inactivo"}
            </span>
          </h4>
        )
      },
    },
    {
      dataField: "actions",
      text: "Acciones",
      sort: false,
      align: "center",
      headerAlign: "center",
      headerStyle: {
        width: "150px",
      },
      formatter: buttonActions,
    },
  ]

  const pageOptions = {
    sizePerPage: 10,
    totalSize: courseKnowledges?.length,
    custom: true,
    showTotal: true,
  }

  const defaultSorted = [{ dataField: "knowledge", order: "asc" }]

  // Select All Button operation
  const selectRow = {
    mode: "checkbox",
    clickToSelect: false,
  }

  return loading || courseKnowledges === undefined ? (
    <div className="mt-3 mb-3">
      <div className="spinner-chase">
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
      </div>
    </div>
  ) : (
    <Fragment>
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="idKnowledge"
        columns={columns}
        data={courseKnowledges}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="idKnowledge"
            columns={columns}
            data={courseKnowledges}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <Row className="mb-2 pt-3">
                  <Col lg={2} md={3} sm={4} xs={6}>
                    <div className="d-grid">
                      <button
                        className="btn btn-primary btn-rounded"
                        onClick={() => setInsertModal(true)}
                      >
                        <i className="fa fa-plus"></i> Agregar conocimiento
                      </button>
                    </div>
                  </Col>
                  <Col
                    lg={{ size: 2, offset: 8 }}
                    md={{ size: 3, offset: 6 }}
                    sm={{ size: 4, offset: 4 }}
                    xs={6}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block">
                      <div className="position-relative">
                        <SearchBar
                          {...toolkitProps.searchProps}
                          placeholder="Buscar"
                        />
                        <i className="bx bx-search-alt search-icon" />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xl="12">
                    <Fragment>
                      <BootstrapTable
                        keyField={"idKnowledge"}
                        bordered={false}
                        striped={true}
                        defaultSorted={defaultSorted}
                        classes={"table align-middle table-nowrap"}
                        headerWrapperClasses={"thead-light"}
                        {...toolkitProps.baseProps}
                        {...paginationTableProps}
                      />
                      {courseKnowledges?.length <= 0 && (
                        <Row>
                          <Col md={12} className="text-center">
                            -- No hay registros --
                          </Col>
                        </Row>
                      )}
                    </Fragment>
                  </Col>
                </Row>

                <Row className="align-items-md-center mt-30">
                  <Col className="inner-custom-pagination d-flex">
                    <div className="d-inline">
                      <SizePerPageDropdownStandalone {...paginationProps} />
                    </div>
                    <div className="text-md-right ms-auto">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
      <Modal
        isOpen={insertModal}
        backdrop={"static"}
        size="lg"
        id="staticBackdrop"
      >
        <div className="modal-header">
          <h5 className="modal-title">Registrar conocimiento</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setInsertModal(false)
            }}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <CourseKnowledgesForm
            onDone={() => {
              dispatch(addCourseKnowledgeClean())
              dispatch(getCourseKnowledges())
              setInsertModal(false)
            }}
            onCancel={() => {
              dispatch(addCourseKnowledgeClean())
              setInsertModal(false)
            }}
            insert={true}
            courseKnowledge={{
              idKnowledge: 0,
              knowledge: "",
              status: true,
            }}
          />
        </div>
      </Modal>
      <Modal
        isOpen={updateModal}
        backdrop={"static"}
        size="lg"
        id="staticBackdrop"
      >
        <div className="modal-header">
          <h5 className="modal-title">Editar conocimiento</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setUpdateModal(false)
            }}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <CourseKnowledgesForm
            onDone={() => {
              dispatch(editCourseKnowledgeClean())
              dispatch(getCourseKnowledges())
              setUpdateModal(false)
            }}
            onCancel={() => {
              dispatch(editCourseKnowledgeClean())
              setUpdateModal(false)
            }}
            insert={false}
            courseKnowledge={courseKnowledge}
          />
        </div>
      </Modal>
    </Fragment>
  )
}

CourseKnowledgeListTable.propTypes = {
  positions: PropTypes.array,
}

export default CourseKnowledgeListTable
